import React from 'react';

interface PropertyLocationProps {
	line1: any
	line2: any
}

const PropertyLocation = ({ line1, line2 }: PropertyLocationProps) => {
	return (
		<article className="d-flex align-items-center mt-3">
			<address className="d-flex flex-wrap align-items-center font--lg leading--tight">
				<div className="leading--tight mb-0">
					<h1 className="cc-font-weight--bold d-inline-block font--lg">{line1}, {line2}</h1>
				</div>
			</address>
		</article>
	);
};

export default PropertyLocation;
